import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SpinnerService } from './spinner.service';
import { finalize } from 'rxjs/operators';


@Injectable()
export class SpinnerInterceptor implements HttpInterceptor {

  private excludedUrls: string[] = [
    '/controller/validarSession',
    '/controller/credito/actualizarCredito/',
    '/controller/productoCredito/getProductoCreditoByidCredito/',
    '/controller/documentos/consultaGarantiasCredito.do',
    '/controller/documentos/consultaDocumentoCredito.do',
    '/controller/avalesCredito/consultaAvalesCredito.do',
    '/controller/coacreditadosCredito/consultaCoacreditados.do',
    '/controller/documentos/consultaDocumentoCredito.do',
    '/controller/documentos/consultaDocumentosContrato',
    '/controller/creditoDocumentos/obtenerImagenById/',
    '/controller/credito/buscar/',
    '/controller/simulador/obtenerTablaAmortizacion/',
    '/controller/credito/datosCliente/lista/',
    '/controller/productoCredito',
    '/controller/notificaciones/notPorUser/',
    '/controller/usuarios/fotoperfilpersona.do',
    '/controller/estatusCredito/consultaListaEstatusCreditoConsultaSaldo.do',
    '/controller/consultarUsuarioPoblacion.do',
    '/controller/producto/buscarPorTipoCredito/',
    '/controller/simulador/guardarTablaAmortizacion/',
    '/controller/productoCredito/getProductoCreditoByidCotizacion/',
    '/controller/validaCredenciales',
    '/controller/documentos/actualizarRegistroDocumentos',
    '/controller/generarReportePDF.do',
    '/controller/consultaPorCodigoPostal.do',
    '/controller/persona/enviaNotificacionPersona/',
    '/controller/persona',
    '/controller/consultaPorEstado.do',
    '/controller/consultaPorEstadoAndMunicipio.do',
    '/controller/consultaPorEstadoAndMunicipioAndCiudad.do',
    '/controller/consultaPorEstadoAndMunicipioAndCiudadTipoAsent.do',
    '/controller/documentos_persona/consultarDocumentosPersona.do',
    'controller/consultarPoblacionByUsuario.do',
    '/controller/creditoConsultaSaldos/ConsultaMetodosDePago',
    '/controller/sucursal/consultaTodasSucursales.do'
  ];

  private excludedUrlsGet: string[] = [
    '/controller/periodicidad',
    '/controller/plazo',
    '/controller/estatusCredito',
    '/controller/consultarPoblacion.do',
    '/controller/producto',
    '/controller/tipoDireccion'
  ]

  constructor(private spinnerService: SpinnerService) { }

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

    const path = new URL(req.url, window.location.origin).pathname;
    let shouldSkip = this.excludedUrls.some(url => path.includes(url));

    if (!shouldSkip) {
      shouldSkip = this.excludedUrlsGet.some(url => path.includes(url) && req.method === 'GET');
    }

    if (!shouldSkip) {
      this.spinnerService.show();
    }

    return next.handle(req).pipe(
      finalize(() => {
        if (!shouldSkip) {
          this.spinnerService.hide();
        }
      })
    );
  }
}